import { Component, OnInit, EventEmitter } from '@angular/core';
import { Log } from 'app/models2/commos/log';
import { DeleteGenericService } from 'app/services/delete-generic.service';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import {
  HeaderFilters,
  params,
  TableColumns,
  TableConfiguration,
  MessageService,
  HttpService,
} from 'brainloper-ui';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.scss'],
})
export class LogsComponent implements OnInit {
  headerFilters: Array<HeaderFilters> = [
    {
      tN: 'logs',
      visibleField: 'fecha_ejecucion',
      labelFilter: 'Fecha Entre',
      type: 'dateRange',
      value: '',
      active: true,
    },
  ];

  public EndpointDictionary = EndpointDictionary;
  public params: params[] = [];

  public titleLog: string = screen.width > 360 ? 'Registro Logs' : 'Logs';
  public reloadTableLog = new EventEmitter<any>();
  public configurationLog: TableConfiguration = {
    primaryKey: 'id',
    delete: true,
    selectable: true,
  };

  public columnsLog: TableColumns<Log>[] = [
    {
      ID: 'date',
      label: 'Fecha',
      type: 'text',
      style: {
        textAlign: 'center',
        width: '100px',
      },
    },
    {
      ID: 'line',
      label: 'Descripción',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'lineNumber',
      label: 'Número Línea',
      type: 'number',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
  ];

  constructor(
    private deleteItem: DeleteGenericService,
    private dialog: MatDialog,
    private messageService: MessageService,
    private http: HttpService
  ) {}

  ngOnInit(): void {}

  async deleteClickRow($event: Log[]) {
    // Mostrar diálogo de confirmación para elegir tipo de eliminación
    const result = await this.messageService.Warning(
      '',
      '¿Qué desea eliminar?',
      true,
      'Registro',
      'Todo el archivo'
    ) as boolean;

    if (result !== undefined) {
      try {
        if (result) {
          // Si resultado es true: eliminar solo la línea
          await this.deleteItem.deleteD(
            $event,
            this.EndpointDictionary.Logs.DELETE_LINE_LOG,
            'id',
            'Registro',
            'Registros'
          );
        } else {
          const uniqueDates = [...new Set($event.map(log => log.date))];
          
          const datesMessage = uniqueDates.length > 1 
            ? `los archivos de las fechas: ${uniqueDates.join(', ')}`
            : `el archivo del ${uniqueDates[0]}`;
          
          const confirmDelete = await this.messageService.Warning(
            'Confirmar eliminación',
            `¿Está seguro de eliminar ${datesMessage}?`,
            true,
            'Aceptar',
            'Cancelar'
          ) as boolean;

          if (confirmDelete) {
            const deletePromises = uniqueDates.map(async (logDate) => {
              const deleteUrl = `${this.EndpointDictionary.Logs.CRUD_LOGS_DATA}/${logDate}`;
              return this.http.deleteDataPromise(deleteUrl);
            });
            
            await Promise.all(deletePromises);
            
            const successMessage = uniqueDates.length > 1
              ? `${uniqueDates.length} archivos eliminados correctamente`
              : 'Archivo eliminado correctamente';
            
            this.messageService.SuccessToast(successMessage);
          }
        }
        this.reloadTableLog.emit();
      } catch (error) {
        this.messageService.Error('Error', 'Error al eliminar los logs');
      }
    }
  }

  async applyFilters($event: Array<HeaderFilters>) {
    if ($event[0].value !== '') {
      let date = $event[0].value.split(',');
      this.params = null
      this.params = [
        {
          id: 'from',
          value: date[0],
        },
        {
          id: 'to',
          value: date[1],
        },
      ];

      setTimeout(() => {
        this.reloadTableLog.emit();
      }, 1000);
    }
    
  }
}
